import { ServerPlanInterface } from "src/store/mine_craft/serverPlansSlice";

// Mirrors ServerPlan::HEX_COLOR on the API side.
export const HEX_COLOR = /^#([a-fA-F0-9]{8}|[a-fA-F0-9]{6}|[a-fA-F0-9]{4}|[a-fA-F0-9]{3})$/;

export const gigabytes = (mb: number) => `${Math.round((mb / 1024) * 10) / 10} GB`;

export const vcpu = (cpuPercent: number) => `${cpuPercent / 100} vCPU`;

// The bullet list a pricing card shows, in the same order as the app's
// plan picker: resources first, then whatever the admin added by hand.
export const planFeatures = (plan: ServerPlanInterface) => [
  `${gigabytes(plan.memory_mb)} of memory`,
  `${plan.max_players} player slots`,
  `${gigabytes(plan.disk_mb)} of storage`,
  vcpu(plan.cpu_percent),
  ...(plan.features || [])
];
